var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.5615C21.732 28.5615 28 22.2935 28 14.5615C28 6.82954 21.732 0.561523 14 0.561523C6.26801 0.561523 0 6.82954 0 14.5615C0 22.2935 6.26801 28.5615 14 28.5615Z",
    fill: "#12C730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9068 9.65915C21.0311 9.78933 21.0311 10.0004 20.9068 10.1306L11.9977 19.4639C11.938 19.5264 11.8571 19.5615 11.7727 19.5615C11.6883 19.5615 11.6074 19.5264 11.5477 19.4639L7.09319 14.7972C6.96894 14.6671 6.96894 14.456 7.09319 14.3258C7.21745 14.1956 7.41891 14.1956 7.54317 14.3258L11.7727 18.7568L20.4568 9.65915C20.5811 9.52898 20.7825 9.52898 20.9068 9.65915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/accept-icon.83ffe7f469201336a5c1d32c54bee7af.svg";
export { ForwardRef as ReactComponent };